var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373636",
    fillRule: "evenodd",
    d: "M6.875 3.958c0-1.15.933-2.083 2.083-2.083 1.15 0 2.084.933 2.084 2.083h3.333c.917 0 1.667.75 1.667 1.667v3.333c1.15 0 2.083.934 2.083 2.084s-.933 2.083-2.083 2.083v3.333c0 .917-.75 1.667-1.667 1.667h-3.167v-.25c0-1.242-1.008-2.25-2.25-2.25-1.241 0-2.25 1.008-2.25 2.25v.25H3.542c-.917 0-1.667-.75-1.667-1.667v-3.166h.25c1.242 0 2.25-1.009 2.25-2.25 0-1.242-1.008-2.25-2.25-2.25h-.242V5.625c0-.917.742-1.667 1.659-1.667h3.333zm2.5 0c0-.233-.183-.416-.417-.416-.233 0-.416.183-.416.416v1.667h-5l.008 1.767c1.458.566 2.492 1.991 2.492 3.65 0 1.658-1.042 3.083-2.5 3.65v1.766h1.766c.567-1.458 1.992-2.5 3.65-2.5 1.659 0 3.084 1.042 3.65 2.5h1.767v-5h1.667c.233 0 .416-.183.416-.416 0-.234-.183-.417-.416-.417h-1.667v-5h-5V3.958z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default ForwardRef;